import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { getVideo } from "../../api/media";
import { useSelector } from "react-redux";
import {store} from "../../store/configureStore";

export const Video = (props) => {
  const token = store.getState().auth.access_token
  // const [base64src, setbase64src] = useState("");

  // useEffect(() => {
  //   getVideo(props.src)
  //     .then((res) => {
  //       // console.log(res)
  //       // const base64 = Buffer.from(res, "binary").toString("base64");
  //       setbase64src(res);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }, [props.src]);

  // if (base64src === "") {
  //   return (
  //     <img src="data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==" />
  //   );
  // }

  const src = process.env.REACT_APP_BACKEND + 'api/ressource/video' + props.src + "?access_token=" + token

  return <video {...props} src={src} />;
};
